import { ApprovalState, ApprovalUserRole, ReportType } from '@fdm/api-client';
import { ReportFormPage } from '../report-form-control.service';
import { Role } from '@fdm/services';
import { CREATOR_POLICY } from './creator';
import { ADMIN_POLICY } from './admin';
import { FASTREPI_POlICY } from './fastrepi';

export const ReportTypes = [
  ReportType.AnomalyReport,
  ReportType.IntegrityDeficiency,
  ReportType.IntegrityThreat,
  ReportType.ReliabilityDeficiency,
  ReportType.ReliabilityThreat,
  ReportType.TaskDeferral,
];

export const Statuses = [ //ript skipped--riptscored/ript skipped
  ApprovalState.Draft,
  ApprovalState.DraftedForReview,
  ApprovalState.SubmittedToOpsAdvisor,
  ApprovalState.RiskEvaluationScored,
  ApprovalState.PlanConfirmed,
  ApprovalState.RIPTScored,
  ApprovalState.PlanEndorsed,
  ApprovalState.PlanApproved,
  ApprovalState.ResolutionPlanCompleted,
  ApprovalState.ValidationAndVerificationCompleted,
] as const;
export type Status = (typeof Statuses)[number];

// Group types
// export enum Group {
//   Admin = 'admin',
//   Creator = 'creator',
//   RIPTRisk = 'fastrepi',
//   Readonly = 'readonly',
// }

// Updated type structure: Group -> SpecificRole -> ReportType -> ReportFormPage -> ApprovalState[]
export type PageStates = Record<ReportFormPage, ApprovalState[]>;
export type ReportNode = Record<ReportType, Partial<PageStates>>;
export type RoleNode = Record<ApprovalUserRole, Partial<ReportNode>>;
export type Policy = Record<Role, Partial<RoleNode>>;

export const POLICY: Partial<Policy> = {
  [Role.Creator]: CREATOR_POLICY, // +
  [Role.RIPTRisk]: FASTREPI_POlICY, // +
};
